import React from "react"
import classnames from "classnames"
import { usePagination, DOTS } from "./usePagination"
import { ArrowRight, ArrowLeft } from "@styled-icons/bootstrap"
import styled from "styled-components"

const Flex = styled.div`
	display: flex;
	align-items: center;
	justify-items: center;
	@media (max-width: 767px) {
		padding-left: 16px;
		padding-right: 16px;
	}
`

const ArrowL = styled(ArrowLeft)``

const ArrowR = styled(ArrowRight)``

const PageControlContainer = styled.div`
	display: block;
	width: 85px;
	@media (max-width: 767px) {
		width: 48px;
		height: 48px;
		padding: 16px;
		box-sizing: content-box;
	}
`

const Pagination = (props) => {
	const {
		onPageChange,
		totalCount,
		siblingCount = 1,
		currentPage,
		pageSize,
		className,
	} = props

	const paginationRange = usePagination({
		currentPage,
		totalCount,
		siblingCount,
		pageSize,
	})

	if (currentPage === 0 || paginationRange.length < 2) {
		return null
	}

	const onNext = () => {
		onPageChange(currentPage + 1)
	}

	const onPrevious = () => {
		onPageChange(currentPage - 1)
	}

	let lastPage = paginationRange[paginationRange.length - 1]
	return (
		<>
			<Flex>
				<PageControlContainer>
					<div
						className={classnames("page-c-r", {
							disabled: currentPage === 1,
						})}
						onClick={onPrevious}
					>
						<span className="page-controls">
							<ArrowL size="15" color="#555555" />
							<span className="page-control-text-left">Previous</span>
						</span>
					</div>
				</PageControlContainer>
				<div className="page-control-mobile">
					Page &nbsp; <span>{currentPage}</span>
					<span>/</span>
					<span>{lastPage}</span>
				</div>
				<ul
					className={classnames("pagination-container", {
						[className]: className,
					})}
				>
					{paginationRange.map((pageNumber) => {
						if (pageNumber === DOTS) {
							return (
								<li className="pagination-item dots" key={pageNumber}>
									&#8230;
								</li>
							)
						}

						return (
							<li
								className={classnames("pagination-item page-n", {
									selected: pageNumber === currentPage,
								})}
								onClick={() => onPageChange(pageNumber)}
								key={pageNumber}
							>
								{pageNumber}
							</li>
						)
					})}
				</ul>
				<PageControlContainer>
					<div
						className={classnames("page-c-l", {
							disabled: currentPage === lastPage,
						})}
						onClick={onNext}
					>
						<span className="page-controls">
							<span className="page-control-text-right">Next</span>
							<ArrowR size="15" color="#555555" />
						</span>
					</div>
				</PageControlContainer>
			</Flex>
		</>
	)
}

export default Pagination
